export function escapeInterval(interval: string): string {
  if (interval.includes('+')) {
    return interval.replace(/\+/g, '%2B');
  }
  return interval;
}
